import Styles from './sideCharacters.module.css';

type Props = {
  imagePath: string;
};

// 性格診断の各ページ（一覧・質問・結果）共通: 広い画面で中央カラムの
// 両脇に同じキャラクター画像を飾りとして立たせる。左側は内向きに反転。
const SideCharacters: React.FC<Props> = ({ imagePath }) => (
  <>
    <img src={imagePath} alt="" aria-hidden="true" className={`${Styles.sideCharacter} ${Styles.sideCharacterLeft}`} />
    <img src={imagePath} alt="" aria-hidden="true" className={`${Styles.sideCharacter} ${Styles.sideCharacterRight}`} />
  </>
);

export default SideCharacters;
